var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H11.75V4.25H10.5V3ZM13 3H14.25V4.25H13V3ZM10.5 5.5H11.75V6.75H10.5V5.5ZM13 5.5H14.25V6.75H13V5.5ZM10.5 8H11.75V9.25H10.5V8ZM13 8H14.25V9.25H13V8ZM10.5 10.5H11.75V11.75H10.5V10.5ZM13 10.5H14.25V11.75H13V10.5ZM10.5 13H11.75V14.25H10.5V13ZM13 13H14.25V14.25H13V13ZM15.5 0.5H9.25C8.91848 0.5 8.60054 0.631696 8.36612 0.866117C8.1317 1.10054 8 1.41848 8 1.75V5.5H1.75C1.41848 5.5 1.10054 5.6317 0.866116 5.86612C0.631696 6.10054 0.5 6.41848 0.5 6.75V19.25C0.5 19.5815 0.631696 19.8995 0.866116 20.1339C1.10054 20.3683 1.41848 20.5 1.75 20.5H15.5C15.8315 20.5 16.1495 20.3683 16.3839 20.1339C16.6183 19.8995 16.75 19.5815 16.75 19.25V1.75C16.75 1.41848 16.6183 1.10054 16.3839 0.866117C16.1495 0.631696 15.8315 0.5 15.5 0.5ZM5.5 19.25H4.25V16.75H5.5V19.25ZM6.75 19.25V15.5H3V19.25H1.75V6.75H8V19.25H6.75ZM13 19.25H11.75V16.75H13V19.25ZM15.5 19.25H14.25V15.5H10.5V19.25H9.25V1.75H15.5V19.25ZM3 8H4.25V9.25H3V8ZM5.5 8H6.75V9.25H5.5V8ZM3 10.5H4.25V11.75H3V10.5ZM5.5 10.5H6.75V11.75H5.5V10.5ZM3 13H4.25V14.25H3V13ZM5.5 13H6.75V14.25H5.5V13Z",
    fill: "#0072FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.2ae0f9e0dbce6dc30674745820a1b01f.svg";
export { ForwardRef as ReactComponent };